/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { ControlTable } from "../../components/Table";
import { getParams } from "../../utils/params";
import { get, isEmpty, isFunction, isNull, isNaN } from "lodash";
import {
  companyApproved,
  companyPause,
  getCompanies,
} from "../../apis/admin/companies";
import Modal from "../Modal";
import Managers from "../Manager/Mangers";
import { ModalHeader } from "reactstrap";
import useForm from "../../hooks/useForm";
import Filters from "../Filters";

import { COMPANY_TYPE, COMPANY_STATE } from "../../constants/COMPANY";
import ToolTip from "../ToolTip/ToolTip";
import { comma } from "../../utils/number";
import systemAlert from "../../utils/systemAlert";

const Companies = ({ companyList = null, setCareCompany = null }) => {
  const [fields] = useState([
    {
      title: "타입",
      label: "-",
      key: "type",
      className: "text-align-center",
      onValue: (val, fields, form) => {
        let type = "기업";
        switch (val) {
          case 2:
            type = "세무사";
            type += `\n(${form.code})`;
            break;
          case 3:
            type = "노무사";
            break;
          case 9:
            type = "경리대행";
            break;

          default:
            break;
        }
        return type;
      },
    },
    {
      title: "사용버전(맴버쉽)",
      label: "-",
      key: "state",
      className: "text-align-center",
      onValue: (val, fields, form) => {
        let type = "-";
        if (val === 1) { // 승인
          if (form.type === 1) { // 기업
            if (!isEmpty(form.taxCompany) || !isNaN(Number(form.taxCompanyIdx))) {
              type = form?.companyMembership?.membership?.label || 'full';
            } else {
              type = form?.companyMembership?.membership?.label || "free";
            }
          } else {
            type = "full";
          }
        }
        return type;
      },
    },
    { title: "상호", label: "-", key: "name", className: "text-align-center" },
    { title: "사업자번호", label: "-", key: "comNum", transform: "comNum" },
    {
      title: "대표자명",
      label: "-",
      key: "ceoName",
      onValue: (value, fileds, data) => {
        const ceos = data.employees.filter(
          (e) => get(e, "companyRoleEmployees[0].companyRole.type", null) === 1
        );
        return (
          <>
            {value}
            {!isEmpty(ceos) && (
              <ToolTip
                tooltiptext={ceos
                  .map(
                    (c) => `${c.name}(${c.userId}) / ${c.mobile} / ${c.email}`
                  )
                  .join("\n\n")}
                position="bottom"
              ></ToolTip>
            )}
          </>
        );
      },
    },
    { title: "직원수", label: "-", key: "employees", onValue: (data) => comma(data.length) },
    ...(isNull(companyList) ? [
      { title: "경리대행사", label: "-", key: "masterCompany.name" },
      { title: "담당세무사", label: "-", key: "taxCompany.name" },
      { title: "담당노무사", label: "-", key: "laborCompany.name" },
      { title: "최초접근세무사", label: '-', key: "throughTaxCompanyCodeCompany.name" },
      {
        title: '가입일',
        key: 'createdTime',
        type: 'date'
      }
    ] : []),
    {
      title: "승인 상태",
      label: "-",
      key: "state",
      onTranslator: { list: COMPANY_STATE },
    },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      onValue: (value, fileds, data) => {
        return data.state === 1 ? "일시중지" : "승인";
      },
      onClick: ({ data }) => {


        systemAlert(`${data.name} ${data.state === 1 ? "일시중지" : "승인"}하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                if (data.state === 1) {
                  companyPause(data.idx).then(() => {
                    reSubmit();
                    if (isFunction(setCareCompany)) {
                      data.state = 2;
                      setCareCompany(data);
                    }

                  });
                } else {
                  companyApproved(data.idx).then(() => {
                    reSubmit();

                    if (isFunction(setCareCompany)) {
                      data.state = 1;
                      setCareCompany(data);
                    }
                  });
                }
              }
            }
          ]
        });


      },
    },
    ...(isNull(companyList) ? [
      {
        type: "button",
        size: "x-sm",
        color: "gray-line",
        label: "매니징 수정",
        onClick: ({ data }) => {
          setManagerViewCompany(data);
        },
      },
    ] : []),
  ]);
  const [managerViewCompany, setManagerViewCompany] = useState(null);

  const {
    form,
    setSubmit,
    handleOnChange,
    reSubmit,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedList,
    setSelectedList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
  } = useForm({
    // searchType: 'name',
    // searchText: '',
    order: [
      {
        idx: "desc",
      },
    ],
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    setIsLoading(true)
    submit(form);
    setSubmit(submit);
  }, [page, limit]);

  const submit = (param) => {
    if (isNull(companyList))

      param.order = [{ "idx": "desc", },];

    if (isEmpty(param.version) || (param.version !== "full" && param.version !== "free")) {
      delete param.version;
    }

    getCompanies(getParams(param))
      .then((res) => {
        setIsLoading(false);
        setTotal(get(res, "data.total"));
        setList(get(res, "data.companies"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
        setSelectedList([]);
      });
  };

  const [filters] = useState([
    {
      title: "타입",
      type: "select",
      key: "search.type",
      defaultValue: "",
      options: {
        list: [{ label: "전체", value: "" }, ...COMPANY_TYPE],
      },
    },
    {
      title: "사용버전",
      type: "select",
      key: "version",
      defaultValue: "",
      options: {
        list: [{ label: "전체", value: "" }, { label: "full", value: "full" }, { label: "free", value: "free" }],
      },
    },
    {
      title: "회사상태",
      type: "select",
      key: "search.state",
      defaultValue: "",
      options: {
        list: [{ label: "전체", value: "" }, ...COMPANY_STATE],
      },
    },
    {
      title: "상호",
      key: "search.name",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "사업자번호",
      key: "search.comNum",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "대표이름",
      key: "search.ceoName",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ]);

  return (
    <>
      {isNull(companyList) &&
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
      }
      <ControlTable
        fields={fields}
        isHidePagination={!isNull(companyList)}
        isHideControlHeader={!isNull(companyList)}
        list={companyList || list}
        isLoading={isLoading}
        // buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        // isControl={true}
        isControl={false}
      />
      <Modal
        isOpen={!!managerViewCompany}
        close={() => {
          setManagerViewCompany(null);
          reSubmit();
        }}
      >
        {managerViewCompany && (
          <>
            <ModalHeader>{managerViewCompany.name} 매니저 관리</ModalHeader>
            <Managers targetCompany={managerViewCompany}></Managers>
          </>
        )}
      </Modal>
    </>
  );
};

export default Companies;
